import { motion } from 'framer-motion';
import { IconStar, IconStarFilled } from '@tabler/icons-react';
import { Card } from '../components/ui/card';

const GalleryPage = () => {
  const reviews = [
    {
      name: 'Анна Сергеева',
      rating: 5,
      text: 'Отличная парикмахерская! Без записи, быстро и качественно. Мастер Яна — профессионал своего дела!',
      date: '2 дня назад'
    },
    {
      name: 'Дмитрий Петров',
      rating: 5,
      text: 'Хожу сюда всей семьёй. Удобно, что не нужно записываться заранее. Цены приятные, качество на высоте.',
      date: '1 неделя назад'
    },
    {
      name: 'Елена Иванова',
      rating: 5,
      text: 'Каждая 6-я стрижка бесплатно — это супер! Уже накопила и получила подарок. Спасибо РИО!',
      date: '2 недели назад'
    },
    {
      name: 'Сергей Михайлов',
      rating: 4,
      text: 'Хорошая стрижка, приемлемые цены. Иногда бывает очередь, но ждать недолго.',
      date: '3 недели назад'
    },
    {
      name: 'Мария Козлова',
      rating: 5,
      text: 'Очень довольна! Мастер Роксана сделала шикарное окрашивание. Буду ходить только сюда.',
      date: '1 месяц назад'
    },
    {
      name: 'Владимир Смирнов',
      rating: 5,
      text: 'Отличный сервис для всей семьи. Стригусь сам, привожу сына. Всё быстро и качественно.',
      date: '1 месяц назад'
    }
  ];

  return (
    <div className="min-h-screen bg-background bg-noise">
      <motion.section
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
        className="py-12 sm:py-16"
      >
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl text-center mb-12">Отзывы клиентов</h1>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {reviews.map((review, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.2, delay: index * 0.05, ease: 'easeOut' }}
              >
                <Card className="bg-card border-[0.5px] border-[color:hsl(var(--hairline))] rounded-[128px] p-6" data-testid="review-card">
                  <div className="flex items-center justify-between mb-3">
                    <h3 className="font-medium">{review.name}</h3>
                    <div className="flex items-center gap-0.5">
                      {[...Array(5)].map((_, i) => (
                        i < review.rating ? (
                          <IconStarFilled key={i} size={16} className="text-[color:hsl(var(--brand-orange))]" />
                        ) : (
                          <IconStar key={i} size={16} className="text-[color:hsl(var(--foreground))]/30" />
                        )
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-[color:hsl(var(--foreground))]/70 mb-3 leading-relaxed">
                    {review.text}
                  </p>
                  <p className="text-xs text-[color:hsl(var(--foreground))]/50">{review.date}</p>
                </Card>
              </motion.div>
            ))}
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default GalleryPage;